import React, { useEffect } from 'react';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import SEO from '../../../components/SEO';
import './cookies.css';

const CookiesPolitik = () => {
  useEffect(() => {
    // Check for CookieYes periodically
    const checkCookieYes = () => {
      if (window.cookieyes) {
        console.log('CookieYes loaded successfully');
        return true;
      }
      return false;
    };

    // Try to detect CookieYes loading
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max
    
    const interval = setInterval(() => {
      attempts++;
      if (checkCookieYes() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const openCookieSettings = () => {
    console.log('Attempting to open cookie settings...');
    console.log('CookieYes object:', window.cookieyes);
    
    if (window.cookieyes) {
      // Try different methods CookieYes might use
      if (typeof window.cookieyes.openPreferences === 'function') {
        console.log('Using openPreferences method');
        window.cookieyes.openPreferences();
      } else if (typeof window.cookieyes.show === 'function') {
        console.log('Using show method');
        window.cookieyes.show();
      } else if (typeof window.cookieyes.showSettings === 'function') {
        console.log('Using showSettings method');
        window.cookieyes.showSettings();
      } else {
        console.warn('No known CookieYes method found. Available methods:', Object.keys(window.cookieyes));
        alert('Cookie indstillinger kunne ikke åbnes. Dette kan skyldes at funktionen ikke er tilgængelig på localhost.');
      }
    } else {
      console.warn('CookieYes not loaded');
      alert('CookieYes er ikke indlæst endnu. Dette fungerer kun på den live hjemmeside, ikke på localhost.');
    }
  };
  return (
    <div className="cookies-page">
      <SEO 
        title="Cookie Politik | Parla Branding"
        description="Information om hvordan Parla Branding bruger cookies. Administrer dine cookie-præferencer og læs om dataindsamling på vores hjemmeside."
        url="https://www.parlabranding.dk/cookies"
        canonicalUrl="https://www.parlabranding.dk/cookies"
      />
      
      <Header />
      
      <main className="cookies-main">
        <div className="container">
          <div className="cookies-header">
            <h1>Cookie Politik</h1>
            <p className="cookies-updated">Sidst opdateret: 24. juli 2025</p>
          </div>

          <div className="cookies-content">
            <section className="cookies-section">
              <h2>Hvad er cookies?</h2>
              <p>
                Cookies er små tekstfiler, der gemmes på din computer eller mobile enhed, når du besøger vores hjemmeside. 
                De hjælper os med at forbedre din brugeroplevelse og giver os mulighed for at analysere, hvordan vores 
                hjemmeside bruges.
              </p>
            </section>

            <section className="cookies-section">
              <h2>Hvordan bruger vi cookies?</h2>
              <p>Vi bruger cookies til følgende formål:</p>
              <ul>
                <li><strong>Nødvendige cookies:</strong> Disse cookies er nødvendige for at hjemmesiden kan fungere korrekt</li>
                <li><strong>Analytiske cookies:</strong> Hjælper os med at forstå, hvordan besøgende interagerer med hjemmesiden</li>
                <li><strong>Marketing cookies:</strong> Bruges til at vise relevante annoncer og måle effektiviteten af vores markedsføring</li>
                <li><strong>Funktionalitets cookies:</strong> Gør det muligt for hjemmesiden at huske dine præferencer</li>
              </ul>
            </section>

            <section className="cookies-section">
              <h2>Typer af cookies vi bruger</h2>
              
              <div className="cookie-category">
                <h3>Nødvendige cookies</h3>
                <p>
                  Disse cookies er afgørende for, at hjemmesiden kan fungere ordentligt. De kan ikke deaktiveres 
                  i vores systemer. De indstilles normalt kun som reaktion på handlinger, du foretager, og som 
                  svarer til en anmodning om tjenester.
                </p>
              </div>

              <div className="cookie-category">
                <h3>Analytiske cookies</h3>
                <p>
                  Vi bruger Google Analytics til at indsamle anonyme data om, hvordan vores hjemmeside bruges. 
                  Dette hjælper os med at forbedre brugeroplevelsen og optimere vores indhold.
                </p>
              </div>

              <div className="cookie-category">
                <h3>Marketing cookies</h3>
                <p>
                  Disse cookies sporer din aktivitet på tværs af hjemmesider for at hjælpe annoncører med at 
                  levere mere relevante annoncer. De kan også bruges til at begrænse antallet af gange, 
                  du ser en annonce.
                </p>
              </div>

              <div className="cookie-category">
                <h3>Funktionalitets cookies</h3>
                <p>
                  Disse cookies gør det muligt for hjemmesiden at levere forbedret funktionalitet og 
                  personalisering. De kan sættes af os eller af tredjepartsudbydere.
                </p>
              </div>
            </section>

            <section className="cookies-section">
              <h2>Tredjeparters cookies</h2>
              <p>Vi bruger følgende tredjepartstjenester, der kan sætte cookies:</p>
              <ul>
                <li><strong>Google Analytics:</strong> Til webanalyse og brugerstatistik</li>
                <li><strong>Google Fonts:</strong> Til at vise skrifttyper på hjemmesiden</li>
                <li><strong>CookieYes:</strong> Til at administrere dit cookiesamtykke</li>
              </ul>
            </section>

            <section className="cookies-section">
              <h2>Sådan administrerer du cookies</h2>
              <p>
                Du kan til enhver tid ændre dine cookieindstillinger ved at klikke på "Cookie-indstillinger" 
                nederst på siden. Du kan også administrere cookies gennem din browsers indstillinger.
              </p>
              
              <div className="cookie-controls">
                <button 
                  className="cookie-settings-btn"
                  onClick={openCookieSettings}
                >
                  Administrer cookie-indstillinger
                </button>
              </div>

              <h3>Browserindstillinger</h3>
              <p>Du kan også administrere cookies gennem din browsers indstillinger:</p>
              <ul>
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/da/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/da-dk/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
                <li><a href="https://support.microsoft.com/da-dk/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noopener noreferrer">Internet Explorer</a></li>
              </ul>
            </section>

            <section className="cookies-section">
              <h2>Opdateringer af denne politik</h2>
              <p>
                Vi kan opdatere denne cookiepolitik fra tid til anden for at afspejle ændringer i vores praksis 
                eller af andre operationelle, juridiske eller regulatoriske årsager. Datoen for den seneste 
                opdatering er angivet øverst på denne side.
              </p>
            </section>

            <section className="cookies-section">
              <h2>Kontakt os</h2>
              <p>
                Hvis du har spørgsmål om vores brug af cookies, er du velkommen til at kontakte os:
              </p>
              <div className="contact-info">
                <p><strong>E-mail:</strong> kontakt@parlabranding.dk</p>
                <p><strong>Telefon:</strong> +45 36 17 00 00</p>
                <p><strong>Adresse:</strong> København, Danmark</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CookiesPolitik;
